<template>
    <div>
        <h5 class="mb-3">
            <strong>Cette année</strong>, avez-vous eu des problèmes (courbatures, douleurs, gênes, engourdissements...)
            au niveau des zones du corps suivants ?
        </h5>
        <section v-if="isLoaded && isLoadedEdit">
            <div class="evaluationItem my-4" v-for="(part, key) in bodyParts" :key="key">
                <div class="evaluationItem__container">
                    <div class="evaluationItem__container__img">
                        <img :src="'/static/img/nordic/' + key + '.png'" :alt="key"/>
                    </div>
                    <div class="evaluationItem__container__content"><strong>{{ part }}</strong></div>
                    <div class="evaluationItem__container__actions">
                        <switch-extended
                                :value="form.hasYear[key] === undefined ? null : form.hasYear[key]"
                                @input="input({$event, key})" invert class="mx-2"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    import SwitchExtended from "../../SwitchExtended";

    export default {
        name: 'evaluation-nordique-year',
        components: {SwitchExtended},
        props: {
            pains: Object
        },
        data: () => ({
            isLoaded: false,
            isLoadedEdit: false,
            form: {
                hasYear: {},
                hasWeek: {},
                douleursWeek: {}
            }
        }),
        mounted(){
            this.isLoaded = false;
            this.form = this.pains;
            this.isLoaded = true;
            this.isLoadedEdit = true;
        },
        methods: {
            input({$event, key}) {
                if (this.isLoaded && this.form.hasYear[key] !== $event) {
                    this.$set(this.form.hasYear, key, $event)
                    this.change();
                }
            },
            change(){
                if (this.isLoaded) {
                    this.isLoadedEdit = false;
                    this.$emit('change', {data: this.form})
                    this.isLoadedEdit = true;
                }
            }
        },
        computed: {
            bodyParts() {
                return this.$store.getters['base/evaluation/nordic/bodyParts']
            },
            colors() {
                return this.$store.getters['base/evaluation/nordic/colors']
            }
        }
    }
</script>
